export default "__VITE_ASSET__C9EMdXyr__"